var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c("div", { staticClass: "main-content" }, [
        _vm.trunkLineEnable &&
        _vm.type === _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code
          ? _c("div", [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MainlineRate")))
              ]),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid-wrapper", {
                    staticStyle: { height: "100%" },
                    attrs: {
                      "config-module": "2025050241",
                      "grid-options": _vm.fcl.gridOptions,
                      "column-defs": _vm.fcl.columnDefs,
                      "row-data": _vm.trunkLineData,
                      "show-selected-color": false,
                      "check-sub-record": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.fcl.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code
                ? _c(
                    "div",
                    { staticClass: "pagination-wrapper" },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "2025050241",
                          total: _vm.trunkLineDataTotal,
                          page: _vm.fcl.filter.pageNum,
                          limit: _vm.fcl.filter.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(_vm.fcl.filter, "pageNum", $event)
                          },
                          "update:limit": function($event) {
                            return _vm.$set(_vm.fcl.filter, "pageSize", $event)
                          },
                          pagination: function($event) {
                            return _vm.$emit("pagination", _vm.fcl.filter)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm.trunkLineEnable &&
        _vm.type === _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code
          ? _c("div", [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_MainlineRate")))
              ]),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid-wrapper", {
                    staticStyle: { height: "100%" },
                    attrs: {
                      "config-module": "2025061602",
                      "grid-options": _vm.lcl.gridOptions,
                      "column-defs": _vm.lcl.columnDefs,
                      "row-data": _vm.trunkLineData,
                      "show-selected-color": false,
                      "check-sub-record": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.lcl.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code
                ? _c(
                    "div",
                    { staticClass: "pagination-wrapper" },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "2025061602",
                          total: _vm.trunkLineDataTotal,
                          page: _vm.lcl.filter.pageNum,
                          limit: _vm.lcl.filter.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(_vm.lcl.filter, "pageNum", $event)
                          },
                          "update:limit": function($event) {
                            return _vm.$set(_vm.lcl.filter, "pageSize", $event)
                          },
                          pagination: function($event) {
                            return _vm.$emit("pagination", _vm.lcl.filter)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm.prePortEnable
          ? _c("div", [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_PrePortRate")))
              ]),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid-wrapper", {
                    staticStyle: { height: "100%" },
                    attrs: {
                      "config-module": "2025050242",
                      "grid-options": _vm.prePort.gridOptions,
                      "column-defs": _vm.prePort.columnDefs,
                      "row-data": _vm.prePortData,
                      "show-selected-color": false,
                      "check-sub-record": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.prePort.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code
                ? _c(
                    "div",
                    { staticClass: "pagination-wrapper" },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "2025050242",
                          total: _vm.prePortDataTotal,
                          page: _vm.prePort.filter.pageNum,
                          limit: _vm.prePort.filter.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.prePort.filter,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.prePort.filter,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: function($event) {
                            return _vm.$emit("pagination", _vm.prePort.filter)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e(),
        _vm.lastMileEnable
          ? _c("div", [
              _c("span", [
                _vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_EndRouteRate")))
              ]),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid-wrapper", {
                    staticStyle: { height: "100%" },
                    attrs: {
                      "config-module": "2025050243",
                      "grid-options": _vm.lastMile.gridOptions,
                      "column-defs": _vm.lastMile.columnDefs,
                      "row-data": _vm.lastMileData,
                      "show-selected-color": false,
                      "check-sub-record": false
                    },
                    on: {
                      gridReady: function(params) {
                        _vm.lastMile.gridApi = params.api
                      }
                    }
                  })
                ],
                1
              ),
              _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code
                ? _c(
                    "div",
                    { staticClass: "pagination-wrapper" },
                    [
                      _c("cargo-pagination", {
                        attrs: {
                          "config-module": "2025050243",
                          total: _vm.lastMileDataTotal,
                          page: _vm.lastMile.filter.pageNum,
                          limit: _vm.lastMile.filter.pageSize
                        },
                        on: {
                          "update:page": function($event) {
                            return _vm.$set(
                              _vm.lastMile.filter,
                              "pageNum",
                              $event
                            )
                          },
                          "update:limit": function($event) {
                            return _vm.$set(
                              _vm.lastMile.filter,
                              "pageSize",
                              $event
                            )
                          },
                          pagination: function($event) {
                            return _vm.$emit("pagination", _vm.lastMile.filter)
                          }
                        }
                      })
                    ],
                    1
                  )
                : _vm._e()
            ])
          : _vm._e()
      ]),
      _vm.trunkLineDetailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code &&
      _vm.type === _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code
        ? _c("price-dialog", {
            attrs: {
              visible:
                _vm.trunkLineDetailDialog.visible &&
                _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code &&
                _vm.type ===
                  _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_FCL.code,
              price: _vm.trunkLineDetailDialog.data,
              "price-addon": null,
              "is-dangerous": null,
              level: 0
            },
            on: {
              close: function($event) {
                _vm.trunkLineDetailDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.trunkLineDetailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code &&
      _vm.type === _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code
        ? _c("price-dialog", {
            attrs: {
              visible:
                _vm.trunkLineDetailDialog.visible &&
                _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code &&
                _vm.type ===
                  _vm.SystemConstants.PRICE_INQUIRY_TYPE_SEA_LCL.code,
              "is-fcl": false,
              price: _vm.trunkLineDetailDialog.data,
              level: 0
            },
            on: {
              close: function($event) {
                _vm.trunkLineDetailDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.trunkLineDetailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code &&
      _vm.type === _vm.SystemConstants.PRICE_INQUIRY_TYPE_AIR.code
        ? _c("air-price-dialog", {
            attrs: {
              visible:
                _vm.trunkLineDetailDialog.visible &&
                _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code &&
                _vm.type === _vm.SystemConstants.PRICE_INQUIRY_TYPE_AIR.code,
              price: _vm.trunkLineDetailDialog.data
            },
            on: {
              close: function($event) {
                _vm.trunkLineDetailDialog.visible = false
              }
            }
          })
        : _vm._e(),
      _vm.prePort.detailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible:
                  _vm.prePort.detailDialog.visible &&
                  _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code,
                "close-on-click-modal": false,
                width: "1537px"
              },
              on: {
                close: function($event) {
                  _vm.prePort.detailDialog.visible = false
                }
              }
            },
            [
              _c("price-pre-port-detail", {
                ref: "pricePrePortDetail",
                attrs: { look: true, "is-dialog": true }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.lastMile.detailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible:
                  _vm.lastMile.detailDialog.visible &&
                  _vm.dataType === _vm.SystemConstants.DATA_TYPE_PRICE.code,
                "close-on-click-modal": false,
                width: "1537px"
              },
              on: {
                close: function($event) {
                  _vm.lastMile.detailDialog.visible = false
                }
              }
            },
            [
              _c("price-last-mile-detail", {
                ref: "priceLastMileDetail",
                attrs: { look: true, "is-dialog": true }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.trunkLineDetailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_QUOTATION.code
        ? _c("quotation-detail-dialog", {
            attrs: {
              visible: _vm.trunkLineDetailDialog.quotationVisible,
              model: _vm.trunkLineDetailDialog.data,
              "show-quotation-detail": true
            },
            on: {
              "update:visible": function($event) {
                return _vm.$set(
                  _vm.trunkLineDetailDialog,
                  "quotationVisible",
                  $event
                )
              }
            }
          })
        : _vm._e(),
      _vm.prePort.detailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_QUOTATION.code
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible:
                  _vm.prePort.detailDialog.visible &&
                  _vm.dataType === _vm.SystemConstants.DATA_TYPE_QUOTATION.code,
                "close-on-click-modal": false,
                width: "1537px"
              },
              on: {
                close: function($event) {
                  _vm.prePort.detailDialog.visible = false
                }
              }
            },
            [
              _c("quotation-pre-port-detail", {
                ref: "pricePrePortDetail",
                attrs: { "is-dialog": true }
              })
            ],
            1
          )
        : _vm._e(),
      _vm.lastMile.detailDialog.visible &&
      _vm.dataType === _vm.SystemConstants.DATA_TYPE_QUOTATION.code
        ? _c(
            "el-dialog",
            {
              attrs: {
                visible:
                  _vm.lastMile.detailDialog.visible &&
                  _vm.dataType === _vm.SystemConstants.DATA_TYPE_QUOTATION.code,
                "close-on-click-modal": false,
                width: "1537px"
              },
              on: {
                close: function($event) {
                  _vm.lastMile.detailDialog.visible = false
                }
              }
            },
            [
              _c("quotation-last-mile-detail", {
                ref: "priceLastMileDetail",
                attrs: { "is-dialog": true }
              })
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }